import { render } from "./DatasetDialog.vue?vue&type=template&id=3aa640c4&scoped=true"
import script from "./DatasetDialog.vue?vue&type=script&lang=js"
export * from "./DatasetDialog.vue?vue&type=script&lang=js"

import "./DatasetDialog.vue?vue&type=style&index=0&id=3aa640c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa640c4"]])

export default __exports__